module.exports = __webpack_public_path__ + "static/linkedin-9fec94fa9e0a1d95c9fd733e9b2d0f83.png";